import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React from "react";

export type HeaderBudgetProps = {
    createRoute?: string;
    mode?: 'list' | 'form';
    title?: string,
    subtitle?:string,

}

export function HeaderFinancialClass(props: HeaderBudgetProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();


    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Classes Financeiras'}
                mode={props.mode}
                subtitle={props.subtitle ?? 'Gestão das classes financeiras'}
                onCreateLink={getCreateLink()}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                onCreateLabel={'Adicionar Classe'}
            />
        </>
    );

}